import {Component, isDevMode, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {APP_CONFIG} from 'src/app/config';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  token: string;
  appVersion: string;

  constructor(private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.token = this.activatedRoute.snapshot.params['token'];
    this.displayVersion();
  }

  private displayVersion() {
    // if (isDevMode()) {
      this.appVersion = APP_CONFIG.appVersion;
    // }
  }
}
